module.exports = __webpack_public_path__ + "img/logo.c29b96e0.svg";